export default __webpack_public_path__ + "static/media/airplane.7aeae36d.svg";